import React, { useCallback, useEffect, useRef, useState } from "react";
import "./FestivalPostConfiguration.scss";
import TemplateTypes01 from "../../.././TemplateTypes01.png";
import Avatar from "../../../Avatar.jpg";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import TextField from "@mui/material/TextField";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import LeftArrowIcon from "../../../../../components/icons/LeftArrowIcon";
import RightArrowIcon from "../../../../../components/icons/RightArrowIcon";
import PreviewModal from "../../propertypost/view/PreviewModal";
import { CommonEnums } from "../../../../../enums/common.enums";
import { CommonHelpers } from "../../../../../utils/helpers/common.helpers";
import CustomPageLoader from "../../../../../components/loaders/CustomPageLoader";
import { TemplatesApi } from "../../../../../utils/api/Templates";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";
import UpdateTemplateModal from "../../../WorkspaceSheduleConfigure/UpdateTemplateModal";
import { clientRoutes } from "../../../../../utils/routes";
import { Modal } from "@mui/material";
import { getImageUrl } from "../../../../../utils/helpers/common";
import { PropertyApi } from "../../../../../utils/api/Property";

const FestivalPostConfiguration = () => {
  const [activeTabs, setActiveTabs] = useState("auctionInfo");
  const [activeTab, setActiveTab] = useState("Facebook");
  const [sameTextToggle, setSameTextToggle] = useState(false);
  const [activeDotIndex, setActiveDotIndex] = useState(0);
  const [showScheduleForm, setShowScheduleForm] = useState(false);
  // const [date, setDate] = useState("");
  const [isExpanded, setIsExpanded] = useState(false);
  const [otherImagesIndex, setOtherImagesIndex] = useState(0);
  const [postPreviewIndex, setPostPreviewIndex] = useState(0);
  // const [timeTo, setTimeTo] = useState("00:00");
  const [isLoading, setIsLoading] = useState(true);
  const [isUpdateMainTemplateOpen, setIsUpdateMainTemplateOpen] =
    useState(false);
  const [isUpdateOtherImagesTemplateOpen, setIsUpdateOtherImagesTemplateOpen] =
    useState(false);
  const [selectedMainTemplateId, setSelectedMainTemplateId] = useState("");
  const [selectedOtherImagesTemplateId, setSelectedOtherImagesTemplateId] =
    useState("");
  const [activePostType, setActivePostType] = useState("Video Post");
  const allowedPostTypes = ["Image Post"];
  const [mainImageUrl, setMainImageUrl] = useState("");
  const [currentTemplateId, setCurrentTemplateId] = useState("");
  const [otherImagesUrl, setOtherImagesUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [selectedPostType, setSelectedPostType] = useState<string | null>(null);
  const [confirmedPostType, setConfirmedPostType] = useState<string | null>(
    null
  );
  const scheduleFormRef = useRef<HTMLDivElement | null>(null);
  const [loadingPostType, setLoadingPostType] = useState<string | null>(null);
  const [step, setStep] = useState("select");
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const [festivalPost, setFestivalPost] = useState<any>(null);
  const { festivalPostId } = useParams<{ festivalPostId: string }>();
  const [error, setError] = useState<string | null>(null);
  const [isPolling, setIsPolling] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [previewImages, setPreviewImages] = useState<string[]>([]);
  const [previewIndex, setPreviewIndex] = useState<number>(0);
  const [scheduleDateTime, setScheduleDateTime] = useState<dayjs.Dayjs | null>(
    null
  );
  const navigate = useNavigate();
  const [processingModalOpen, setProcessingModalOpen] = useState(false);
  const [isUpdateTemplateOpen, setIsUpdateTemplateOpen] = useState(false);
  const listingType = searchParams.get("listing_type") || undefined;
  const postType = searchParams.get("post_type") || undefined;
  const [localPostStatus, setLocalPostStatus] = useState<string | null>(null);
  const [selectedButton, setSelectedButton] = useState("schedule");
  const [updating, setUpdating] = useState(false);
  const [scheduleDate, setScheduleDate] = useState<Dayjs | null>(null);
  const [scheduleTime, setScheduleTime] = useState<Dayjs | null>(null);
  const [timeTo, setTimeTo] = useState("00:00");
  const [date, setDate] = useState<string>("");

  const templateTypeId = resolveReviewTemplateType(postType, listingType);

  const postTypes = [
    { label: "Image Post" },
    { label: "Video Post" },
    { label: "Story Post" },
    { label: "Reel Post" },
  ];

  const tabs = [
    "Facebook",
    "Instagram",
    "Google Business",
    "Linkedin",
    "Youtube",
  ];

  const images = [
    "/images/property-inside.jpg",
    "https://images.pexels.com/photos/1571460/pexels-photo-1571460.jpeg",
    "https://as2.ftcdn.net/jpg/02/61/89/29/1000_F_261892957_6jyBXvEgM79iYr1eEiJKCosnVPJdvHHr.jpg",
  ];

  const handleOtherImagesPrev = () => {
    setOtherImagesIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleOtherImagesNext = () => {
    setOtherImagesIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const handlePostPreviewPrev = () => {
    setPostPreviewIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handlePostPreviewNext = () => {
    setPostPreviewIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const fullText = `Featuring: 5 🛌  Bedrooms | 5 🛀  Bathrooms | 2 🚗 Car Spaces... more
💸 Price Range: $1,675,000 - $1,842,000
Discover a lifestyle that's more than extraordinary – it's truly exceptional. Nestled in the heart of Berwick Waters, this stunning property at 6 Rockbank Road offers everything you need to live like a star.
Don't miss the chance to experience the allure of celebrity living. Come and see what makes 6 Rockbank Road the ultimate address for those who demand the best.
Your dream lifestyle awaits!
📸 Explore More: https://www.realestate.com.au/property-house-vic-clyde...
For more information or to book a viewing,

Lern more at BrandFeeds [Brand feeds Link for this property here]

Contact
Sukhdeep Singh 📲 0420 879 430
Mohan Singh 📲 0426 250 579
#celebrityliving #dreamhome #luxurylifestyle #clydenorthrealestate 
#berwickwaters #melbournerealestate #homesforsale #luxuryhomes 
#realestategoals #propertyforsale #dreamliving #familyhome 
#investmentproperty`;

  const shortText = `Experience Celebrity Living at 📍 6 Rockbank Road, Clyde North Spaces...`;

  const handleUpdateTemplateConfirm = (
    templateId: string,
    imageUrl: string
  ) => {
    setCurrentTemplateId(templateId);
    setMainImageUrl(imageUrl);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    setTimeout(() => setLoading(false), 3000);
  }, []);

  const handleConfirm = () => {
    if (selectedPostType) {
      setConfirmedPostType(selectedPostType);
      setLoadingPostType(selectedPostType);
      setTimeout(() => {
        setLoadingPostType(null);
        setStep("configure");
      }, 1500);
    }
  };

  const handlePostTypeClick = (type: string) => {
    if (selectedPostType && selectedPostType !== type) {
      setLoadingPostType(selectedPostType);
    }

    setSelectedPostType(type);

    setTimeout(() => {
      setLoadingPostType(null);
      setStep("confirm");
    }, 800);
  };

  const handleShowScheduleForm = () => {
    setShowScheduleForm(true);

    setTimeout(() => {
      scheduleFormRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  };

  useEffect(() => {
    if (festivalPost?.schedule_datetime) {
      setScheduleDateTime(dayjs(festivalPost.schedule_datetime));
      setShowScheduleForm(true);
    }
  }, [festivalPost]);

  function resolveReviewTemplateType(postType?: string, listingType?: string) {
    if (
      postType === CommonEnums.postTypes.image_post &&
      listingType === CommonEnums.listing_Type.rent
    ) {
      return CommonEnums.templateTypes.review_for_rent_image_post.slug;
    }
    if (
      postType === CommonEnums.postTypes.story_post &&
      listingType === CommonEnums.listing_Type.rent
    ) {
      return CommonEnums.templateTypes.review_for_rent_story_post.slug;
    }
    if (
      postType === CommonEnums.postTypes.story_post &&
      listingType === CommonEnums.listing_Type.sale
    ) {
      return CommonEnums.templateTypes.review_for_sale_story_post.slug;
    }
    // if (
    //   postType === CommonEnums.postTypes.video_post &&
    //   listingType === CommonEnums.listing_Type.rent
    // ) {
    //   return CommonEnums.templateTypes.open_home_for_rent_video_post.slug;
    // }
    // if (
    //   postType === CommonEnums.postTypes.video_post &&
    //   listingType === CommonEnums.listing_Type.sale
    // ) {
    //   return CommonEnums.templateTypes.open_home_for_sale_video_post.slug;
    // }
    // if (
    //   postType === CommonEnums.postTypes.reel_post &&
    //   listingType === CommonEnums.listing_Type.rent
    // ) {
    //   return CommonEnums.templateTypes.open_home_for_rent_reel_post.slug;
    // }
    // if (
    //   postType === CommonEnums.postTypes.reel_post &&
    //   listingType === CommonEnums.listing_Type.sale
    // ) {
    //   return CommonEnums.templateTypes.open_home_for_sale_reel_post.slug;
    // }
    return CommonEnums.templateTypes.review_for_sale_image_post.slug;
  }

  const fetchPost = useCallback(async () => {
    if (!festivalPostId) return;

    try {
      setLoading(true);

      const res = await PropertyApi.GetFestivalPostById(festivalPostId);

      if (res?.data?.success) {
        const updatedPost = res.data.data;
        setFestivalPost(updatedPost);

        if (updatedPost.schedule_datetime) {
          const dt = dayjs(updatedPost.schedule_datetime);
          setScheduleDateTime(dt);
          setScheduleDate(dt);
          setScheduleTime(dt);
        }
        // console.log("festivalPost", festivalPost);
      } else {
        setError("Failed to load review post");
      }
    } catch (err) {
      console.error("Failed to fetch review post:", err);
      setError("Something went wrong while fetching");
    } finally {
      setLoading(false);
    }
  }, [festivalPostId]);

  useEffect(() => {
    if (festivalPostId) fetchPost();
  }, [festivalPostId, fetchPost]);

  useEffect(() => {
    if (festivalPost?._id) {
      const currentParams: Record<string, string> = {};

      searchParams.forEach((value, key) => {
        currentParams[key] = value;
      });

      setSearchParams({
        ...currentParams,
        post_type: festivalPost.post_type || "",
      });
    }
  }, [festivalPost, searchParams, setSearchParams]);

  const handleScheduleConfirm = async () => {
    if (!scheduleDate || !scheduleTime) {
      toast.error("Please select both date and time");
      return;
    }

    const scheduleDateTimeISO = dayjs(
      `${scheduleDate.format("YYYY-MM-DD")} ${scheduleTime.format("HH:mm")}`
    ).toISOString();

    try {
      setProcessingModalOpen(true);
      const res = await PropertyApi.updateFestivalPost(
        {
          schedule_datetime: scheduleDateTimeISO,
          schedule_type: "schedule_datetime",
        },
        festivalPostId!
      );

      if (res?.data?.success) {
        setLocalPostStatus("scheduled");
        toast.success("Post scheduled successfully!");
        setShowScheduleForm(false);
      } else {
        toast.error(res?.data?.message || "Failed to update schedule");
      }
    } finally {
      setProcessingModalOpen(false);
    }
  };

  const renderDesignImage = (item: any) => {
    const designActivityRef = item?._id ? item : null;

    const assetUrlRaw = designActivityRef?.design_task_id?.output_image_path;
    const postType =
      designActivityRef?.design_post_type || item?.design_post_type;
    const designTaskStatus = designActivityRef?.design_task_id?.task_status;

    const isLoading = designTaskStatus === CommonEnums.taskStatus.queued;
    const isErrored = designTaskStatus === CommonEnums.taskStatus.errored;

    const assetUrl = assetUrlRaw
      ? CommonHelpers.getImageUrlFromImageTool({ path: assetUrlRaw })
      : null;

    // console.log("Rendering image for design:", assetUrl);
    // console.log("Asset URL raw:", item?.design_task_id?.output_image_path);

    // --- Error State ---
    if (isErrored) {
      return (
        <div className="activity-image-section image-placeholder-container">
          <img
            src="/images/image-video-generation-error-fallback-image-for-card.png"
            alt="Error Preview"
            className="activity-thumbnail placeholder-image"
          />
        </div>
      );
    }

    if (isLoading) {
      const fallback =
        postType === CommonEnums.postType.video_post.key
          ? "/images/square-fallback-image-for-video-preview.png"
          : "/images/square-fallback-image-for-image-preview.png";

      return (
        <div className="activity-image-section image-placeholder-container">
          <img
            src={fallback}
            alt="Loading Preview"
            className="activity-thumbnail placeholder-image"
          />
          <div className="loader-container">
            <CustomPageLoader className="activity-card-loader" />
            <p className="processing-text font-poppins-400">Processing...</p>
          </div>
        </div>
      );
    }

    if (postType === CommonEnums.postType.story_post.key) {
      return (
        <div className="activity-image-section story-post-image-container">
          <img
            src={
              assetUrl ||
              "/images/image-video-generation-error-fallback-image-for-card.png"
            }
            alt="Story Preview"
            className="activity-thumbnail"
            onError={(e: any) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src =
                "/images/image-video-generation-error-fallback-image-for-card.png";
            }}
          />
        </div>
      );
    }

    if (postType === CommonEnums.postType.video_post.key) {
      return (
        <div className="activity-image-section video-placeholder-collection">
          <img
            src={
              assetUrl ||
              "/images/image-video-generation-error-fallback-image-for-card.png"
            }
            alt="Video Preview"
            className="activity-thumbnail"
            onError={(e: any) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src =
                "/images/image-video-generation-error-fallback-image-for-card.png";
            }}
          />
        </div>
      );
    }

    if (postType === CommonEnums.postType.reel_post.key) {
      return (
        <div className="activity-image-section reel-placeholder-collection">
          <img
            src={
              assetUrl ||
              "/images/image-video-generation-error-fallback-image-for-card.png"
            }
            alt="Reel Preview"
            className="activity-thumbnail"
            onError={(e: any) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src =
                "/images/image-video-generation-error-fallback-image-for-card.png";
            }}
          />
        </div>
      );
    }

    return (
      <div className="activity-image-section">
        <img
          src={
            assetUrl ||
            "/images/image-video-generation-error-fallback-image-for-card.png"
          }
          alt="Image Preview"
          className="activity-thumbnail"
          onError={(e: any) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src =
              "/images/image-video-generation-error-fallback-image-for-card.png";
          }}
        />
      </div>
    );
  };

  const designStatuses = [
    festivalPost?.image_post_design_activity_ref?.design_status,
    festivalPost?.story_post_design_activity_ref?.design_status,
    festivalPost?.video_post_design_activity_ref?.design_status,
    festivalPost?.reel_post_design_activity_ref?.design_status,
  ].filter(Boolean);

  const hasPendingForUpload = designStatuses.includes(
    "pending_for_social_media_upload"
  );

  const startPolling = (interval = 3000) => {
    if (isPolling) return;
    setIsPolling(true);

    const postTypeFromUrl =
      searchParams.get("post_type") || festivalPost?.post_type;

    const postTypeMap: Record<string, string> = {
      image_post: "image_post_design_activity_ref",
      story_post: "story_post_design_activity_ref",
      video_post: "video_post_design_activity_ref",
      reel_post: "reel_post_design_activity_ref",
    };

    const designKey = postTypeMap[postTypeFromUrl || ""] || "";

    if (!designKey) {
      console.warn("Unknown post_type:", postTypeFromUrl);
      setIsPolling(false);
      return;
    }

    const timer = setInterval(async () => {
      if (!festivalPostId) return;

      try {
        const res = await PropertyApi.GetFestivalPostById(festivalPostId);
        if (res?.data?.success) {
          const post = res.data.data;

          setFestivalPost((prev: any) => {
            if (
              !prev ||
              prev?.[designKey]?.design_status !==
                post?.[designKey]?.design_status
            ) {
              return post;
            }
            return prev;
          });

          const designStatus = post?.[designKey]?.design_status;

          if (designStatus === "pending_for_social_media_upload") {
            clearInterval(timer);
            setIsPolling(false);
          }
        }
      } catch (err) {
        console.error("Polling error:", err);
      }
    }, interval);
  };

  useEffect(() => {
    if (festivalPost?._id && !isPolling) {
      startPolling(3000);
    }
  }, [festivalPost]);

  const selectedTemplateId = festivalPost
    ? postType === CommonEnums.postTypes.image_post
      ? festivalPost.image_post_design_activity_ref?.design_template_id?._id ||
        festivalPost.template_id?._id ||
        ""
      : postType === CommonEnums.postTypes.story_post
      ? festivalPost.story_post_design_activity_ref?.design_template_id?._id ||
        festivalPost.template_id?._id ||
        ""
      : postType === CommonEnums.postTypes.video_post
      ? festivalPost.video_post_design_activity_ref?.design_template_id?._id ||
        festivalPost.template_id?._id ||
        ""
      : postType === CommonEnums.postTypes.reel_post
      ? festivalPost.reel_post_design_activity_ref?.design_template_id?._id ||
        festivalPost.template_id?._id ||
        ""
      : festivalPost.template_id?._id || ""
    : "";

  const formattedSchedule = festivalPost?.schedule_datetime
    ? dayjs(festivalPost?.schedule_datetime).format(
        "MMMM DD, YYYY [at] hh:mm A"
      )
    : "-";

  const handlePostNow = async () => {
    if (!festivalPostId || updating) return;
    setUpdating(true);
    try {
      const res = await PropertyApi.updateFestivalPost(
        {
          schedule_type: "post_now",
          schedule_datetime: dayjs().toISOString(),
        },
        festivalPostId
      );

      setLocalPostStatus("published");
      setDate(dayjs().format("YYYY-MM-DD"));
      setTimeTo(dayjs().format("HH:mm"));

      if (res?.data?.success) {
        toast.success("Post published successfully!");
        fetchPost();
      } else {
        toast.error(res?.data?.message || "Failed to publish post");
      }
    } catch (error) {
      console.error("Error publishing now:", error);
      toast.error("Something went wrong while publishing");
    } finally {
      setUpdating(false);
    }
  };

  const isPostCompleted =
    localPostStatus === "published" ||
    festivalPost?.schedule_type === "post_now";

  const isScheduleAlreadySet =
    festivalPost?.schedule_type === "schedule_datetime";

  const isPostNow = festivalPost?.schedule_type === "post_now";

  const isReadOnly = festivalPost?.user_type === "agent";

  return (
    <div className="configure-post-container">
      <div className="configure-post">
        <h3 className="section-title">Post Preview</h3>
        <div className="right-actions">
          <button
            className="preview"
            disabled={!hasPendingForUpload}
            onClick={() => {
              if (!hasPendingForUpload) return;

              const designRefs = [
                festivalPost?.image_post_design_activity_ref,
                festivalPost?.story_post_design_activity_ref,
                festivalPost?.video_post_design_activity_ref,
                festivalPost?.reel_post_design_activity_ref,
              ].filter(Boolean);

              const images = designRefs.map((ref) => {
                const path = ref?.design_task_id?.output_image_path;
                return path
                  ? CommonHelpers.getImageUrlFromImageTool({ path })
                  : "/images/image-video-generation-error-fallback-image-for-card.png";
              });

              setPreviewImages(images);
              setPreviewIndex(0);
              setIsPreviewOpen(true);
            }}
          >
            Preview
          </button>

          {/* <button
            className="change-template"
            disabled={!hasPendingForUpload}
            onClick={() => hasPendingForUpload && setIsUpdateTemplateOpen(true)}
          >
            Change Template
          </button> */}
        </div>
      </div>

      <div className={`post-preview-wrapper ${isExpanded ? "expanded" : ""}`}>
        {hasPendingForUpload ? (
          <div className="post-preview-card">
            <div className="post-header">
              <img
                src={
                  getImageUrl(
                    festivalPost?.agent_ref?.profile_image_ref
                      ?.compressed_file_path || ""
                  ) || "/images/profile-placeholder-image.png"
                }
                alt="Agent"
                className="avatar"
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = "/images/profile-placeholder-image.png";
                }}
              />
              <div className="user-info">
                <strong className="name">
                  {festivalPost.agent_ref?.principal_agent_first_name}{" "}
                  {festivalPost.agent_ref?.principal_agent_last_name}
                </strong>
                <span className="date">{formattedSchedule}</span>
              </div>
            </div>

            <div className="post-text">
              <span className="post-content">
                {isExpanded ? fullText : shortText}
              </span>
              <span className="see-more" onClick={toggleExpand}>
                {isExpanded ? " See less" : " See more"}
              </span>
            </div>

            <div className="carousel-container">
              {renderDesignImage(
                [
                  festivalPost?.image_post_design_activity_ref,
                  festivalPost?.story_post_design_activity_ref,
                  festivalPost?.video_post_design_activity_ref,
                  festivalPost?.reel_post_design_activity_ref,
                ].filter(Boolean)[postPreviewIndex]
              )}

              {[
                festivalPost?.image_post_design_activity_ref,
                festivalPost?.story_post_design_activity_ref,
                festivalPost?.video_post_design_activity_ref,
                festivalPost?.reel_post_design_activity_ref,
              ].filter(Boolean).length > 1 && (
                <>
                  <button
                    className="carousel-button left"
                    onClick={() =>
                      setPostPreviewIndex((prev) =>
                        prev === 0
                          ? [
                              festivalPost?.image_post_design_activity_ref,
                              festivalPost?.story_post_design_activity_ref,
                              festivalPost?.video_post_design_activity_ref,
                              festivalPost?.reel_post_design_activity_ref,
                            ].filter(Boolean).length - 1
                          : prev - 1
                      )
                    }
                  >
                    <LeftArrowIcon />
                  </button>

                  <button
                    className="carousel-button right"
                    onClick={() =>
                      setPostPreviewIndex((prev) =>
                        prev ===
                        [
                          festivalPost?.image_post_design_activity_ref,
                          festivalPost?.story_post_design_activity_ref,
                          festivalPost?.video_post_design_activity_ref,
                          festivalPost?.reel_post_design_activity_ref,
                        ].filter(Boolean).length -
                          1
                          ? 0
                          : prev + 1
                      )
                    }
                  >
                    <RightArrowIcon />
                  </button>
                </>
              )}
            </div>

            {[
              festivalPost?.image_post_design_activity_ref,
              festivalPost?.story_post_design_activity_ref,
              festivalPost?.video_post_design_activity_ref,
              festivalPost?.reel_post_design_activity_ref,
            ].filter(Boolean).length > 1 && (
              <div className="dots-pagination">
                {[
                  festivalPost?.image_post_design_activity_ref,
                  festivalPost?.story_post_design_activity_ref,
                  festivalPost?.video_post_design_activity_ref,
                  festivalPost?.reel_post_design_activity_ref,
                ]
                  .filter(Boolean)
                  .map((_, i) => (
                    <span
                      key={i}
                      className={`dot ${
                        i === postPreviewIndex ? "active" : ""
                      }`}
                      onClick={() => setPostPreviewIndex(i)}
                    />
                  ))}
              </div>
            )}
          </div>
        ) : (
          <div className="post-preview-loading">
            <div className="spinner" />
            <h4>Your request is being processed.</h4>
            <p>
              We’re working on your request! Creating a high-quality output can
              take a little while. We appreciate your patience.
            </p>
            <p className="message">
              Feel free to wait here, or browse other pages. We’ll send you a
              notification when your request is completed.
            </p>
          </div>
        )}
      </div>

      <div className="text-config">
        <div className="post-text-header">
          <h4>Post Text</h4>
          <div className="toggle-same-text">
            <label className="switch-label">
              Same text for all the platforms
              <input
                type="checkbox"
                checked={sameTextToggle}
                onChange={() => setSameTextToggle(!sameTextToggle)}
              />
              <span className="slider"></span>
            </label>
          </div>
        </div>
        <div className="platform-header">
          <div className="platform-tabs">
            {tabs.map((tab) => (
              <div
                key={tab}
                className={`platform-tab ${activeTab === tab ? "active" : ""}`}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </div>
            ))}
          </div>
        </div>

        <textarea
          className="post-textarea"
          placeholder="Write your post content here..."
          defaultValue={""}
          onInput={(e: React.FormEvent<HTMLTextAreaElement>) => {
            const target = e.currentTarget;
            target.style.height = "auto";
            target.style.height = `${target.scrollHeight}px`;
          }}
        />
      </div>

      <div className="festival-post-form">
        <h3 className="section-title">Schedule Date & Time</h3>
        <p>Select date and time to schedule post</p>

        {isPostCompleted && (
          <div className="status-message published">
            <p className="auto-post">
              Post is Completed and Published on{" "}
              {festivalPost?.schedule_datetime
                ? dayjs(festivalPost.schedule_datetime).format(
                    "hh:mm A, DD-MM-YYYY"
                  )
                : `${dayjs().format("hh:mm A")}, ${dayjs().format(
                    "DD-MM-YYYY"
                  )}`}
              .
            </p>
          </div>
        )}

        {!isPostCompleted && (
          <div className={`button-group ${isReadOnly ? "disabled" : ""}`}>
            <button
              className={`post-btn ${
                festivalPost?.schedule_type === "post_now" ? "selected" : ""
              }`}
              onClick={handlePostNow}
              disabled={updating || isReadOnly}
            >
              Post Now
            </button>

            <button
              className={`schedule-btn ${
                isScheduleAlreadySet ||
                showScheduleForm ||
                selectedButton === "schedule"
                  ? "active selected"
                  : ""
              }`}
              onClick={() => {
                if (isReadOnly) return;

                if (!isScheduleAlreadySet) {
                  setShowScheduleForm(!showScheduleForm);
                }
                setSelectedButton("schedule");
              }}
              disabled={isReadOnly}
            >
              Schedule Post
            </button>
          </div>
        )}

        {!isPostNow && (
          <div className="datetime-row">
            <div className="datetime-field">
              <label>Date*</label>
              <div className="input-icon-wrapper">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={scheduleDate}
                    onChange={(newValue) => setScheduleDate(newValue)}
                    format="DD/MM/YYYY"
                    disabled={isReadOnly}
                    slots={{ textField: TextField }}
                    slotProps={{
                      textField: {
                        variant: "outlined",
                        size: "small",
                        fullWidth: false,
                        InputProps: {
                          className: "input",
                          readOnly: isReadOnly,
                        },
                        sx: {
                          input: {
                            color: "#000",
                            "&::placeholder": {
                              color: "#333",
                              opacity: 1,
                            },
                          },
                        },
                      },
                    }}
                  />
                </LocalizationProvider>
              </div>
            </div>

            <div className="datetime-field">
              <label>Time*</label>
              <div className="input-icon-wrapper">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <TimePicker
                    value={scheduleTime}
                    onChange={(newValue) => setScheduleTime(newValue)}
                    ampm
                    format="hh:mm A"
                    disabled={isReadOnly}
                    slots={{ textField: TextField }}
                    slotProps={{
                      textField: {
                        variant: "outlined",
                        size: "small",
                        fullWidth: false,
                        InputProps: {
                          className: "input",
                          readOnly: isReadOnly,
                        },
                      },
                    }}
                  />
                </LocalizationProvider>
              </div>
            </div>
          </div>
        )}

        {!isReadOnly && (
          <div className="form-actions">
            <button
              className="discard-btn"
              onClick={() => {
                setScheduleDate(null);
                setScheduleTime(null);
                setShowScheduleForm(false);
              }}
            >
              Discard Changes
            </button>

            <button className="confirm-btn" onClick={handleScheduleConfirm}>
              Save
            </button>
          </div>
        )}
      </div>

      {/* {isUpdateTemplateOpen && festivalPost && (
        <UpdateTemplateModal
          open={isUpdateTemplateOpen}
          onClose={() => setIsUpdateTemplateOpen(false)}
          selectedDesignTemplateId={selectedTemplateId}
          templateTypeId={templateTypeId}
          onConfirm={async () => {
            setProcessingModalOpen(true);

            try {
              await TemplatesApi.updateReviewPost(
                { finalize: true },
                festivalPostId!
              );
              toast.success("Finalized successfully");
              setIsUpdateTemplateOpen(false);
              await fetchPost();
            } catch (err) {
              console.error("Finalize failed:", err);
              toast.error("Failed to finalize");
            } finally {
              setProcessingModalOpen(false);
            }
          }}
        />
      )} */}

      <Modal
        open={processingModalOpen}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            setProcessingModalOpen(false);
          }
        }}
        aria-labelledby="processing-modal"
        className="add-property-modal styled-modal"
        disableEscapeKeyDown
      >
        <div className="modal-center-wrapper">
          <div className="loading-content-wrapper">
            <div className="loading-container">
              <div className="spinner" />
              <p className="loading-text">
                Processing your request
                <span className="desktop-break">
                  <br />
                </span>
                Please wait...
              </p>
            </div>
          </div>
        </div>
      </Modal>

      {isPreviewOpen && (
        <PreviewModal
          open={isPreviewOpen}
          onClose={() => setIsPreviewOpen(false)}
          images={previewImages}
          initialIndex={previewIndex}
        />
      )}
    </div>
  );
};

export default FestivalPostConfiguration;
